// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordContainer":"resetPassword_resetPasswordContainer__2DwIR","formStyle":"resetPassword_formStyle__btSR3"};